<app-sticky-nav [class.accessibility]="accessibility" *ngIf="(displayFullscreen$ | async) === false"></app-sticky-nav>

<main class="container" [class.accessibility]="accessibility" role="main" id="mainContent" tabindex="-1">
  <router-outlet></router-outlet>

  <app-scroll-top
    [scrollDestination]="'#mainContent'"
    [scrollOffset]="-300"
    [containerId]="'mainContent'"
  ></app-scroll-top>
  <app-pre-footer *ngIf="(displayFullscreen$ | async) === false"></app-pre-footer>
</main>

<app-footer
  [class.accessibility]="accessibility"
  *ngIf="(displayFullscreen$ | async) === false"
  (contactUs)="openContactForm()"
></app-footer>
